import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../api.service';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-idrs',
  templateUrl: './idrs.component.html',
  styleUrl: './idrs.component.scss'
})
export class IdrsComponent implements OnInit {
  
  queryParams: any = {}; // To store query parameters

  studyId: string | null = null; // Study ID
  subjectId: string | null = null; // Subject ID
  studyCode: any; // Study Code
  studyName: any; // Study Name
  siteLocation: any; // Site Location
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  folderName: any;
  subjectName: string | null;
  formName: string = 'idrs-form-log';
  formData: any = {
    assessment: []
  };
  idrsData: any[] = [
    {
      loglineNo: 1,
      assessmentType: 'Age (years)',
      criteriaOptions: [
        { label: 'Less than 35 years', value: 0 },
        { label: '35 to 50 years (both years included)', value: 20 },
        { label: 'More than 50 years', value: 30 }
      ],
      selectedCriteria: null,
      scoreToBeGiven: 0,
      
    },
    {
      loglineNo: 2,
      assessmentType: 'Abdominal obesity (waist circumference)',
      criteriaOptionsFemale: [
        { label: 'Less than 80 cm (females)', value: 0 },
        { label: '80 to 89 cm (females)', value: 10 },
        { label: '90 cm or more (females)', value: 20 }
      ],
      criteriaOptionsMale: [
        { label: 'Less than 90 cm (males)', value: 0 },
        { label: '90 to 99 cm (males)', value: 10 },
        { label: '100 cm or more (males)', value: 20 }
      ],
      selectedCriteria: null,
      scoreToBeGiven: 0,
      
    },
    {
      loglineNo: 3,
      assessmentType: 'Physical activity',
      criteriaOptions: [
        { label: 'Exercise regular + strenuous work', value: 0 },
        { label: 'Exercise regular or strenuous work', value: 20 },
        { label: 'No exercise and sedentary work', value: 30 }
      ],
      selectedCriteria: null,
      scoreToBeGiven: 0,
      
    },
    {
      loglineNo: 4,
      assessmentType: 'Family History',
      criteriaOptions: [
        { label: 'Both parents are/were not diabetic', value: 0 },
        { label: 'One parent is/was diabetic (any parent)', value: 10 },
        { label: 'Both parents are/were diabetic', value: 20 }
      ],
      selectedCriteria: null,
      scoreToBeGiven: 0,
      
    }
  ];
  
  //query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: {
    selectedField: any; threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] 
}[] = [
  { selectedField: null, threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end
   // Add these new properties at the top of the IdrsComponent
isIdrsLogDisabled: boolean = false;
isReasonModalOpen: boolean = false;
editReason: string = '';

//review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

 
//logs
 sectionNames = ['Screening', 'Baseline', 'Follow-up'];
 idrsBySection : {
  [section: string]: {
    data: any[],
    isDisabled: boolean,
    editReason: string,
    reviewOptions: { dataMonitor: boolean; monitor: boolean; pi: boolean }
  }
} = {};
  activeSection: string;
  auditTrailData: any;
hasIdrsData: boolean = false; // To track if any section has IDRS data


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);

  const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);
  this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize
  
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;

    this.informedConsentDate = '';
    this.screeningMinDate = '';

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'idrs-form-log';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });

    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
             // Dynamically update informedConsentDate from the response
             if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;  // Set min date
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }
            // Store the gender from the response
          this.gender = response.gender;
          console.log("gender:",this.gender);
          if (response.data) {
            this.mapFormData(response.data); // Ensure data mapping happens AFTER gender is set
        }
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
    
    // Initialize section-wise data (Screening, Baseline, Follow-up)
  this.sectionNames.forEach(section => {
    this.idrsBySection[section] = {
      data: this.idrsData.map(item => ({
        ...JSON.parse(JSON.stringify(item)), // Deep copy
        selectedCriteria: null,
        scoreToBeGiven: 0
      })),
      isDisabled: false,
      editReason: '',
      reviewOptions: { dataMonitor: false, monitor: false, pi: false }
    };
  });


  }
//


  addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}





onReviewCheckboxChange(section: string, role: string, event: any): void {
  const value = event.target.checked;
  if (this.idrsBySection[section]?.reviewOptions) {
    this.idrsBySection[section].reviewOptions[role] = value;
  }
}


  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
     const section = this.activeSection || 'Unknown';
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || `${section} - IDRS Assessment` || 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData( 
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
           this.auditTrailData = auditTrail;
        }else {
          console.warn('No query data found or data is not an array');
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
  if (selected.type === 'fieldHistory') {
    this.fieldHistoryData = [];

    if (this.formName === 'idrs-form-log' && Array.isArray(this.idrsData)) {
  this.idrsData.forEach((_, index) => {
    const fieldName = `${section} - Assessment${index + 1}`;
        this.apiService.getInsertHistoryData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName,
          fieldName
        ).subscribe({
          next: (response) => {
            if (Array.isArray(response.data)) {
              this.fieldHistoryData.push(...response.data);
            }
          },
          error: (error) => {
            console.error('Error fetching field history for ${fieldName}:', fieldName, error);
          }
        });
      });
    } else {
      const fieldName = this.fieldLabel || 'Unknown Field';
      console.log('Fetching Field History for:', fieldName);
      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      ).subscribe({
        next: (response) => {
          console.log('Fetched Field History Data:', response);
          this.fieldHistoryData = response.data || [];
        },
        error: (error) => {
          console.error('Error fetching field history data:', error);
        }
      });
    }
  }


}
  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
 
  this.showReviewModal = true;
  this.fieldHistoryData = [];

  if (!this.activeSection || !this.sectionNames.includes(this.activeSection)) {
    console.warn('Invalid or missing active section for review modal.');
    return;
  }

  const sectionData = this.idrsBySection[this.activeSection];
  if (!sectionData || !Array.isArray(sectionData.data)) {
    console.warn(`No valid data found for section: ${this.activeSection}`);
    return;
  }

  const allReviewEntries: any[] = [];
  let completedRequests = 0;
  const totalRequests = sectionData.data.length;

  sectionData.data.forEach((_, idx) => {
    const fieldName = `${this.activeSection} - Assessment${idx + 1}`;
    console.log('Fetching Field History for:', fieldName);

    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        if (Array.isArray(response.data)) {
          this.fieldHistoryData.push(...response.data);
          allReviewEntries.push(...response.data);
        }

        completedRequests++;
        if (completedRequests === totalRequests) {
          this.calculateLatestReviewFlags(allReviewEntries);
        }
      },
      error: (err) => {
        console.error(`Error fetching field history for ${fieldName}:`, err);
        completedRequests++;
        if (completedRequests === totalRequests) {
          this.calculateLatestReviewFlags(allReviewEntries);
        }
      }
    });
  });
}
calculateLatestReviewFlags(historyData: any[]): void {
  let latestReview = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  const sortedData = [...historyData].sort(
    (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  );

  const flagsFound = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  for (const entry of sortedData) {
    if (!entry.review_status) continue;

    try {
      const parsed = typeof entry.review_status === 'string'
        ? JSON.parse(entry.review_status)
        : entry.review_status;

      if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
        latestReview.dataMonitor = parsed.dataMonitor;
        flagsFound.dataMonitor = true;
      }
      if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
        latestReview.monitor = parsed.monitor;
        flagsFound.monitor = true;
      }
      if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
        latestReview.pi = parsed.pi;
        flagsFound.pi = true;
      }

      if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
        break;
      }
    } catch (err) {
      console.error("Error parsing review_status JSON:", err);
    }
  }

  // ✅ Apply the flags to the correct section
  if (this.activeSection && this.idrsBySection[this.activeSection]) {
    this.idrsBySection[this.activeSection].reviewOptions = { ...latestReview };
    console.log("✅ Applied section review flags:", this.idrsBySection[this.activeSection].reviewOptions);
  } else {
    console.warn("⚠️ Cannot apply reviewOptions, invalid activeSection:", this.activeSection);
  }
}


closeReviewModal() {
  this.showReviewModal = false;
}
openOptionsModal(event: MouseEvent, target: EventTarget | null, section: string) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;
  this.activeSection = section; // Set section context

  // Traverse to the closest parent with `data-label`
  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

  if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}



openModal() {
  if (!this.activeSection) {
    alert("No section selected");
    return;
  }

  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'
  const section = this.activeSection;

  // Use dynamic label if available; else fallback to default format
  const fieldName = this.fieldLabel || `${section} - IDRS Assessment` || 'Unknown Field';
  console.log("Opening modal - Fetching field name:", fieldName);

  // Fetch query history
  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item =>
            typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
          );

          return {
            selectedField: entry.auditTrail?.[0]?.selectedField || '',
            threadId: entry.threadId || 'no-thread',
            text: this.getInitialQueryText(auditTrail) || '',
            isClosed: isClosed,
            auditTrail: auditTrail
          };
        });
      } else {
        this.queries = Array(3).fill(null).map(() => ({
          selectedField: null,
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
        selectedField: null,
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });

  // Fetch field history section-wise (like vital-signs)
  if (this.formName === 'idrs-form-log' && Array.isArray(this.idrsBySection[section]?.data)) {
    this.fieldHistoryData = [];

    this.idrsBySection[section].data.forEach((_, index) => {
      const historyFieldName = `${section} - Assessment${index + 1}`;

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        historyFieldName
      ).subscribe({
        next: (response) => {
          console.log(`History for ${historyFieldName}:`, response);
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data);
          }
        },
        error: (error) => {
          console.error(`Error fetching history for ${historyFieldName}:`, error);
        }
      });
    });
  }
}


getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
     selectedField: null,
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }
  
  if (!query.selectedField) {
  console.warn('No field selected for the query.');
  alert('Please select a field from the dropdown before submitting.');
  return;
}

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    selectedField: query.selectedField || '' // <-- ADD THIS LINE
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}

//
  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code ?? 'N/A';
      this.studyName = studyDetails.study_name ?? 'Unknown Study';
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';
      this.subjectName = this.subjectId;

      console.log("Mapped Study Details:", {
        studyCode: this.studyCode,
        studyName: this.studyName,
        siteLocation: this.siteLocation,
        subjectName: this.subjectName,
      });
    } else {
      console.warn('Study details are missing or undefined.');
    }
  }

  /*mapFormData(data: any[]): void {
    data.forEach(item => {
      const subData = JSON.parse(item.sub_data); // Parse sub_data
  
      // Find the corresponding entry in idrsData using loglineNo
      const existingEntry = this.idrsData.find(entry => entry.loglineNo === subData.loglineNo);
  
      if (existingEntry) {
        // Special handling for 'Abdominal obesity (waist circumference)'
        if (existingEntry.assessmentType === 'Abdominal obesity (waist circumference)') {
          if (this.gender === 'Female') {
            existingEntry.selectedCriteria = existingEntry.criteriaOptionsFemale?.find(option => option.label === subData.selectedCriteria) || null;
          } else if (this.gender === 'Male') {
            existingEntry.selectedCriteria = existingEntry.criteriaOptionsMale?.find(option => option.label === subData.selectedCriteria) || null;
          }
        } else {
          // Default case for other assessments
          existingEntry.selectedCriteria = existingEntry.criteriaOptions?.find(option => option.label === subData.selectedCriteria) || null;
        }
        
        // Assign scoreToBeGiven and scoreGiven
        existingEntry.scoreToBeGiven = subData.scoreToBeGiven;
        existingEntry.scoreGiven = subData.scoreGiven;
  
        // Map criteriaValid if needed
        existingEntry.criteriaValid = subData.criteriaValid;
      }
    });
  
    console.log("Updated IDRS Data:", this.idrsData);
}*/

mapFormData(data: any[]): void {
  console.log("Mapping section-wise IDRS data... Gender:", this.gender);

  let hasData = false; // Flag to indicate if any section has data

  // Initialize each section
  this.sectionNames.forEach(section => {
    if (!this.idrsBySection[section]) {
      this.idrsBySection[section] = {
        data: this.idrsData.map(item => ({
          ...JSON.parse(JSON.stringify(item)),
          selectedCriteria: null,
          scoreToBeGiven: 0,
          scoreGiven: 0,
          criteriaValid: false
        })),
        isDisabled: false,
        editReason: '',
        reviewOptions: { dataMonitor: false, monitor: false, pi: false }
      };
    }
  });

  data.forEach(item => {
    const sectionMatch = item.field_name?.match(/^(Screening|Baseline|Follow-up)/i);
    if (!sectionMatch) return;

    const section = sectionMatch[1];
    const sectionData = this.idrsBySection[section];
    if (!sectionData) return;

    const fieldName = item.field_name?.trim().toLowerCase();

    // ✅ Apply review_status from backend
    if (item.review_status) {
      try {
        const parsedStatus = typeof item.review_status === 'string'
          ? JSON.parse(item.review_status)
          : item.review_status;

        sectionData.reviewOptions.dataMonitor ||= parsedStatus.dataMonitor || false;
        sectionData.reviewOptions.monitor ||= parsedStatus.monitor || false;
        sectionData.reviewOptions.pi ||= parsedStatus.pi || false;
      } catch (e) {
        console.warn("Invalid review_status JSON:", item.review_status);
      }
    }

    // ✅ Handle legacy review checkbox names in field_name (optional fallback)
    if (fieldName.includes('reviewedbydatamonitor')) {
      sectionData.reviewOptions.dataMonitor = item.value === 'true';
    } else if (fieldName.includes('reviewedbymonitor')) {
      sectionData.reviewOptions.monitor = item.value === 'true';
    } else if (fieldName.includes('reviewedbypi')) {
      sectionData.reviewOptions.pi = item.value === 'true';
    }

    // ✅ Handle sub_data mapping
    let subData: any = {};
    try {
      subData = typeof item.sub_data === 'string' ? JSON.parse(item.sub_data) : item.sub_data;
    } catch {
      console.warn('Invalid JSON in sub_data → skipped:', item.sub_data);
      return;
    }

    const entryIndex = this.idrsData.findIndex(e => e.loglineNo === subData.loglineNo);
    if (entryIndex === -1 || !sectionData.data[entryIndex]) return;

    const targetEntry = sectionData.data[entryIndex];

    // Gender-specific logic
    if (subData.assessmentType === 'Abdominal obesity (waist circumference)') {
      if (this.gender === 'Female') {
        targetEntry.selectedCriteria = targetEntry.criteriaOptionsFemale?.find(opt => opt.label === subData.selectedCriteria) || null;
      } else if (this.gender === 'Male') {
        targetEntry.selectedCriteria = targetEntry.criteriaOptionsMale?.find(opt => opt.label === subData.selectedCriteria) || null;
      }
    } else {
      targetEntry.selectedCriteria = targetEntry.criteriaOptions?.find(opt => opt.label === subData.selectedCriteria) || null;
    }

    targetEntry.scoreToBeGiven = subData.scoreToBeGiven ?? 0;
    targetEntry.scoreGiven = subData.scoreGiven ?? 0;
    targetEntry.criteriaValid = subData.criteriaValid ?? false;

    if (targetEntry.selectedCriteria || targetEntry.scoreGiven || targetEntry.criteriaValid) {
      hasData = true;
    }
  });

  // ✅ Disable section if it has any data
  this.sectionNames.forEach(section => {
    const sectionData = this.idrsBySection[section];
    sectionData.isDisabled = sectionData.data.some(
      item => item.selectedCriteria || item.scoreGiven || item.criteriaValid
    );
  });

  this.hasIdrsData = hasData;

  console.log('✅ Mapped Section-wise IDRS Data with Review:', this.idrsBySection);
}

calculateScore(section: string, index: number) {
  const sectionData = this.idrsBySection[section]?.data;
  if (!sectionData || !sectionData[index]) return;

  const selectedOption = sectionData[index].selectedCriteria;
  if (selectedOption) {
    sectionData[index].scoreToBeGiven = selectedOption.value;
  } else {
    sectionData[index].scoreToBeGiven = 0;
  }
}

getTotalScoreGiven(section: string): number {
  const sectionData = this.idrsBySection[section]?.data || [];
  return sectionData.reduce((total, item) => total + Number(item.scoreGiven || 0), 0);
}


onScoreGivenChange(section: string): void {
  // Just for change detection if needed
}

  // Add these methods
editStudy() {
  this.isReasonModalOpen = true;
}

confirmEditReason() {
  if (!this.activeSection) return;
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }
  // this.isIdrsLogDisabled = false;
  // this.isReasonModalOpen = false;
   const section = this.activeSection;
  this.idrsBySection[section].isDisabled = false;
  this.idrsBySection[section].editReason = this.editReason.trim();
  this.isReasonModalOpen = false;

}

cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}
  
  submitForm(section: string) {
    const sectionData = this.idrsBySection[section];
    console.log("Before Extracting IDRS Form Data:", this.idrsData);
    const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
    let questionAnswers: { [key: string]: any } = {};

     if (this.formName === 'idrs-form-log' && Array.isArray(sectionData.data)) {
    sectionData.data.forEach((item, index) => {
      const fieldKey = `${section} - Assessment${index + 1}`;
            
            questionAnswers[fieldKey] = {
                answer: "yes",
                value: {
                    loglineNo: item.loglineNo,
                    assessmentType: item.assessmentType,
                    selectedCriteria: item.selectedCriteria ? item.selectedCriteria.label : null, // Send selected label
                    criteriaValid: item.criteriaValid ?? false,
                    scoreToBeGiven: item.scoreToBeGiven ?? 0,
                    scoreGiven: item.scoreGiven ?? 0
                },
                 editReason: sectionData.editReason || '',
                 reviewStatus: { ...sectionData.reviewOptions }
            };
        });
    }

    console.log("Submitted IDRS Data:", questionAnswers);

    const submittedData = {
        folderName: this.folderName,
        formName: this.formName,
        studyId: this.studyId,
        subjectId: this.subjectId,
        user: fullName,
        section: section,
        ...questionAnswers
    };

    console.log("Form Submitted:", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
        next: (response) => {
            console.log("Response from API:", response);
            alert("IDRS Form Submitted Successfully!");
            this.editReason = '';
          this.isIdrsLogDisabled = true;
          sectionData.isDisabled = true; 
        },
        error: (error) => {
            console.error("Error submitting IDRS form:", error);
            alert("Error submitting form. Please try again.");
        }
    });
}


goBack() {
  this.router.navigate(['/study-details', this.studyId]);
}
//new + import line to allow. closing of panel
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
    if (!clickedInside) {
      this.isOptionsModalOpen = false;
    }
  }

}
